import * as React from "react";
import { IOWidget, mk_widget, option, Options } from "../widget";

export type NumberOptions = Options & {
  kind?:"number" | "slider",
  min?:number,
  max?:number
}

interface NumberProps {
  options?:NumberOptions
  input?:number,
  on_done:(output:number) => void
}
interface NumberState { }

class Number extends React.Component<NumberProps, NumberState> {
  constructor(props:NumberProps, context:any) {
    super(props, context)

    this.state = {}
  }

  render() {
    return this.props.options && this.props.options.readonly ?
        <span {...(option("extraProperties", this.props.options) || {})}
              id={option("id", this.props.options)}
              key={this.props.options ? this.props.options.key : undefined}
              style={this.props.options ? this.props.options.style : undefined}
              >{this.props.input}</span>
      :
        <input  {...(option("extraProperties", this.props.options) || {})}
              id={option("id", this.props.options)}
              key={this.props.options ? this.props.options.key : undefined}
              readOnly={this.props.options && this.props.options.readonly}
              type={this.props.options && this.props.options.kind == "slider" ? "range" : "number"}
              min={option("min", this.props.options)}
              max={option("max", this.props.options)}
              style={this.props.options ? this.props.options.style : undefined}
              value={this.props.input} onChange={e => {
                let v = e.currentTarget.valueAsNumber
                let min = option("min", this.props.options)
                let max = option("max", this.props.options)
                if (min && v < min) return
                if (max && v > max) return
                this.props.on_done(v)
              } } />
  }
}

/** @deprecated Use [[wrapHTML]] instead. */
export const number = (options?:NumberOptions) : IOWidget<number | undefined, number> => input => mk_widget({
  run:(on_done:(output:number) => void) =>
    React.createElement<NumberProps>(Number, { on_done, input, options })
})
